import { Typography } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import ErrorScreen from "~/modules/app/screens/ErrorScreen";
import LoadingScreen from "~/modules/app/screens/LoadingScreen";
import { parseStringToDate } from "~/modules/app/util/dateHelpers";

import { useInvoiceForPeriod } from "../api/useInvoiceForPeriod";
import { Invoice } from "../components/Invoice";

export function InvoiceDetailScreenBreadcrumb(match: { params: { invoiceId: string } }) {
    const { data } = useInvoiceForPeriod(match.params.invoiceId);
    const { t } = useTranslation("invoice");
    return (
        data?.periodEnd &&
        t("detail.invoiceForPeriod", {
            period: format(parseStringToDate(data.periodEnd), "MMMM yyyy"),
        })
    );
}

export function InvoiceDetailScreen() {
    const { t } = useTranslation("invoice");

    const { invoiceId } = useParams();
    if (invoiceId === undefined) throw new Error("Missing parameter `invoiceId`");
    const { data, error } = useInvoiceForPeriod(invoiceId);

    return (
        <GaiaPageLayoutColumn maxWidth="xl">
            {error !== undefined ? (
                <ErrorScreen error={error} />
            ) : data === undefined ? (
                <LoadingScreen />
            ) : data === null ? (
                <Typography>{t("detail.emptyPage")}</Typography>
            ) : (
                <Invoice data={data} />
            )}
        </GaiaPageLayoutColumn>
    );
}
